const initialState = {
  baseUrl: "/api",
  headers: null
};

export default (state=initialState, action) => {
  if(action.type == "ADD_HTTP_HEADERS"){
    const { headers } = action;

    return Object.assign({}, state, {
      headers: Object.assign({}, state.headers || {}, headers)
    });
  }

  return state;
}
